<template>
    <div>
        <v-form method="post" id="nativeForm" v-model="valid">
            <v-row justify="center" v-if="chk_save == true">
                <v-col cols="12" md="10">
                    <v-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-col cols="12" class="text-center">
                                    <span class="fh-444">
                                        {{
                                            show.emp_id +
                                                " วันที่ " +
                                                show.date_survey +
                                                " เวลา " +
                                                show.time +
                                                " น."
                                        }}
                                    </span>
                                    <br />
                                    <br />
                                    <span class="fh-4">
                                        ทำแบบสำรวจเรียบร้อย
                                    </span>
                                    <br />
                                    <br />
                                    <span class="fh-44">
                                        ขอบคุณทุกท่านที่ให้ความร่วมมือ
                                    </span>

                                    <br />
                                    <br />
                                    <span class="fh-444">
                                        หากผู้ใดจงใจปิดข้อมูลหรือแจ้งข้อมูลเท็จ
                                        ขอสงวนสิทธิ์ในการจ่าย incentive หรือ
                                        mileage และมีบทลงโทษ
                                    </span>
                                </v-col>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify="center" v-if="chk_save == false">
                <v-col cols="12" md="10">
                    <v-card>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <span class="fh-11 mb-2 ml-2"
                                    >Daily health check and timeline</span
                                >
                                <v-col cols="12" sm="5" md="4">
                                    <video
                                        ref="camerapc"
                                        :width="300"
                                        autoplay
                                        playsinline
                                    ></video>
                                </v-col>
                                <v-col cols="12" sm="5" md="8">
                                    <v-text-field
                                        v-model="staff.emp_id"
                                        @input="checkstaff(staff.emp_id)"
                                        style="font-size:25px;width:200px"
                                        outlined
                                        label="รหัสพนักงาน"
                                        maxlength="7"
                                        :rules="empR"
                                    ></v-text-field>
                                    <v-btn
                                        class="mar-t-15 mb-5"
                                        rounded
                                        color="green"
                                        :disabled="!valid || this.num_1 == 0"
                                        @click="save_form()"
                                    >
                                        <span class="ml-3 mr-3 white--text"
                                            >บันทึกแบบสำรวจ</span
                                        >
                                    </v-btn>
                                    <div
                                        v-if="
                                            data.emp_name != '' &&
                                                data.emp_name !== undefined
                                        "
                                    >
                                        <p class="fh-3">{{ data.emp_name }}</p>
                                        <p class="fh-3">
                                            Location :
                                            {{ distance_used.branch_name }}
                                        </p>
                                        <p
                                            class="primary--text mar-t-10 mb-5"
                                            v-if="gps.lat"
                                        >
                                            {{
                                                "(" +
                                                    gps.lat +
                                                    " , " +
                                                    gps.lng +
                                                    ")"
                                            }}
                                        </p>
                                    </div>
                                    <p class="primary--text">
                                        สามารถ Check Point ได้ตั้งแต่เวลา 19:00
                                        – 24:00 ครับ
                                    </p>
                                    <p
                                        class="red--text "
                                        style="font-size:20px; text-decoration:underline"
                                    >
                                        หากผู้ใดจงใจปิดข้อมูลหรือแจ้งข้อมูลเท็จ
                                        ขอสงวนสิทธิ์ในการจ่าย incentive หรือ
                                        mileage และมีบทลงโทษ
                                    </p>
                                </v-col>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>
            <v-fade-transition
                mode="out-in"
                v-if="
                    data.emp_name != '' &&
                        data.emp_name !== undefined &&
                        chk_save == false
                "
            >
                <v-row justify="center">
                    <v-col cols="12" md="10">
                        <v-card>
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title class="headline mb-1">
                                        <v-row>
                                            <v-col cols="12" md="6"
                                                >คัดกรองและป้องกันการติดโควิด</v-col
                                            >
                                        </v-row>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <!-- xx -->
                                    </v-list-item-subtitle>

                                    <!-- 111 -->
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="fh-1">
                                                1. ใน24ชม. ที่ผ่านมา
                                                ท่านมีอาการเหล่านี้หรือไม่
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-20"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_1)
                                                "
                                                v-model="form_save.q1_1"
                                                label="ไม่มีอาการ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-20"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_2)
                                                "
                                                v-model="form_save.q1_2"
                                                label="มีน้ำมูก"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <!-- <v-checkbox color="primary" value="Y">
                                        <template v-slot:label>
                                            <div>
                                                ไม่มีอาการ
                                                <span class="red--text"
                                                    >แต่ได้ทานยาลดไข้</span
                                                >
                                            </div>
                                        </template>
                                    </v-checkbox> -->
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_3)
                                                "
                                                v-model="form_save.q1_3"
                                                label="ไม่มีอาการ แต่ทานยาลดไข้ / ยาแก้ไอ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_4)
                                                "
                                                v-model="form_save.q1_4"
                                                label="จมูกไม่ได้กลิ่น"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_5)
                                                "
                                                v-model="form_save.q1_5"
                                                label="ปวดเมื่อย"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_6)
                                                "
                                                v-model="form_save.q1_6"
                                                label="ลิ้นรับรสน้อยลง"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_7)
                                                "
                                                v-model="form_save.q1_7"
                                                label="มีไข้"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_8)
                                                "
                                                v-model="form_save.q1_8"
                                                label="เจ็บคอ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_9)
                                                "
                                                v-model="form_save.q1_9"
                                                label="ปวดศรีษะ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_10)
                                                "
                                                v-model="form_save.q1_10"
                                                label="หายใจเหนื่อยหอบ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_11)
                                                "
                                                v-model="form_save.q1_11"
                                                label="ไอ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_12)
                                                "
                                                v-model="form_save.q1_12"
                                                label="หนาวสั่น"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_13)
                                                "
                                                v-model="form_save.q1_13"
                                                label="คัดจมูก"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="mar-t-30"
                                        >
                                            <v-checkbox
                                                @change="
                                                    func_num(form_save.q1_14)
                                                "
                                                v-model="form_save.q1_14"
                                                label="ปอดอักเสบ"
                                                color="primary"
                                                value="Y"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>

                                    <!-- 222 -->
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-1">
                                                2. ใน 7วันที่ผ่านมา พนง.
                                                หรือคนในบ้านเดินทางไป ตจว
                                                หรือไม่
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q2"
                                                row
                                                :rules="q2R"
                                            >
                                                <v-radio
                                                    label="ไม่มี "
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มี"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mar-t-50"
                                            v-if="form_save.q2 == 'Y'"
                                        >
                                            <v-text-field
                                                :rules="q2R_remark"
                                                v-model="form_save.q2_remark"
                                                :value="form_save.q2_remark"
                                                label="โปรดระบุ...จังหวัด"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- 333 -->
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-1">
                                                3. ใน 7 วันที่ผ่านมา
                                                คนในครอบครัวที่พักอยู่ด้วยกัน
                                                หรือ ชุมชนที่ท่านอาศัยอยู่
                                                ได้มีการตรวจโควิดหรือไม่
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q3"
                                                row
                                                :rules="q3R"
                                            >
                                                <v-radio
                                                    label="ไม่มี"
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มี"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mar-t-50"
                                            v-if="form_save.q3 == 'Y'"
                                        >
                                            <v-text-field
                                                :rules="q3R_remark"
                                                v-model="form_save.q3_remark"
                                                :value="form_save.q3_remark"
                                                label="โปรดระบุ...ความใกล้ชิด หรือบริเวณนั้นๆ / เหตุผลที่รับการตรวจ(ถ้าทราบข้อมูล)"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- 555 -->
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-1">
                                                4. ใน 24 ชม. หลังเลิกงาน
                                                และวันหยุด มีนัดเจอ กิน ดื่ม
                                                มากกว่า 2 คนขึ้นไป หรือไม่
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q5"
                                                row
                                                :rules="q5R"
                                            >
                                                <v-radio
                                                    label="ไม่มี"
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มี"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mar-t-50"
                                            v-if="form_save.q5 == 'Y'"
                                        >
                                            <v-text-field
                                                :rules="q5R_remark"
                                                v-model="form_save.q5_remark"
                                                :value="form_save.q5_remark"
                                                label="โปรดระบุ...ความสัมพันธ์ และ สถานที่"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- 666 -->
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-1">
                                                5. ใน 24 ชม.
                                                ท่านมีสนทนาโดยไม่ใส่หน้ากากกับบุคคลใดบ้าง
                                                โปรดระบุให้ครบถ้วน
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q6"
                                                row
                                                :rules="q6R"
                                            >
                                                <v-radio
                                                    label="ไม่มี"
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มี"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mar-t-50"
                                            v-if="form_save.q6 == 'Y'"
                                        >
                                            <v-text-field
                                                :rules="q6R_remark"
                                                v-model="form_save.q6_remark"
                                                :value="form_save.q6_remark"
                                                label="โปรดระบุ...ความสัมพันธ์ สถานที่ และช่วงเวลา"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- 444 -->
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-2">
                                                6. ใน 24
                                                ชม.ที่ผ่านมาท่านได้เดินทางไป ตจว
                                                / บ้านญาติ / บ้านเพื่อน /
                                                7ELEVEN/ ตลาด - ตลาดนัด /
                                                ห้างสรรพสินค้า (ในจังหวัด) หรือ
                                                นัดพบเพื่อน หรือไม่
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q4"
                                                row
                                                :rules="q4R"
                                            >
                                                <v-radio
                                                    label="ไม่มี"
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มี"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mar-t-50"
                                            v-if="form_save.q4 == 'Y'"
                                        >
                                            <v-text-field
                                                :rules="q4R_remark"
                                                v-model="form_save.q4_remark"
                                                :value="form_save.q4_remark"
                                                label="โปรดระบุ...สถานที่"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- 411 -->
                                    <v-row class="mar-t-20">
                                        <v-col cols="12">
                                            <span class="fh-2">
                                                6.1 ใน 24 ชม.ได้มีการนัดพบเพื่อน
                                                พนง. บริษัท ACA / AGS นอกออฟฟิศ
                                                หรือไม่
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q4_1"
                                                row
                                                :rules="q41R"
                                            >
                                                <v-radio
                                                    label="ไม่มี"
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มีพบเจอเพื่อน พนง บริษัทฯ"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mar-t-50"
                                            v-if="form_save.q4_1 == 'Y'"
                                        >
                                            <v-text-field
                                                :rules="q41R_remark"
                                                v-model="form_save.q4_1_remark"
                                                :value="form_save.q4_1_remark"
                                                label="โปรดระบุ... ชื่อ และ สถานที่"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <!-- 422 -->
                                    <v-row class="mar-t-20">
                                        <v-col cols="12">
                                            <span class="fh-2">
                                                6.2 โปรดระบุ Time ใน 24 ชม.
                                                ที่ผ่านมาเวลาโดยละเอียด
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="4"
                                            md="2"
                                            class="text-right"
                                        >
                                            <span class="fh-3">
                                                เมื่อวาน 19:01 น. - วันนี้ 7.00
                                                น.
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="8"
                                            md="10"
                                            class="mar-t-30"
                                        >
                                            <v-text-field
                                                :rules="q421R"
                                                v-model="form_save.q4_2_1"
                                                label="โปรดระบุ... Time line"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="4"
                                            md="2"
                                            class="text-right"
                                        >
                                            <span class="fh-3">
                                                วันนี้ 07.01 น. – วันนี้ 10.00
                                                น.
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="8"
                                            md="10"
                                            class="mar-t-30"
                                        >
                                            <v-text-field
                                                :rules="q422R"
                                                v-model="form_save.q4_2_2"
                                                label="โปรดระบุ... Time line"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="4"
                                            md="2"
                                            class="text-right"
                                        >
                                            <span class="fh-3">
                                                วันนี้ 10.00 น. – วันนี้ 13.00
                                                น.
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="8"
                                            md="10"
                                            class="mar-t-30"
                                        >
                                            <v-text-field
                                                :rules="q423R"
                                                v-model="form_save.q4_2_3"
                                                label="โปรดระบุ... Time line"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="4"
                                            md="2"
                                            class="text-right"
                                        >
                                            <span class="fh-3">
                                                วันนี้ 13.01 น. – วันนี้ 16.00
                                                น.
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="8"
                                            md="10"
                                            class="mar-t-30"
                                        >
                                            <v-text-field
                                                :rules="q424R"
                                                v-model="form_save.q4_2_4"
                                                label="โปรดระบุ... Time line"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="4"
                                            md="2"
                                            class="text-right"
                                        >
                                            <span class="fh-3">
                                                วันนี้ 16.01 น. – วันนี้ 19.00
                                                น.
                                            </span>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="8"
                                            md="10"
                                            class="mar-t-30"
                                        >
                                            <v-text-field
                                                :rules="q425R"
                                                v-model="form_save.q4_2_5"
                                                label="โปรดระบุ... Time line"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        class="mar-t-20"
                                        v-if="form_save.q4_onsite"
                                    >
                                        <v-col cols="12">
                                            <span class="red--text">
                                                เคส Onsite ในวันนี้
                                            </span>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                disabled
                                                outlined
                                                label="เคส Onsite ในวันนี้"
                                                required
                                                v-model="form_save.q4_onsite"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>

                                    <!-- 777 -->
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-1">
                                                7. ใน24ชม.
                                                ที่ผ่านมาท่านล้างมือด้วยแอลกอฮอล์ขณะปฎิบัติหน้าที่หรือไม่
                                                <span class="red--text"
                                                    >(เฉพาะ SVC / Onsite)</span
                                                >
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q7"
                                                row
                                                :rules="
                                                    form_save.q7_validate == 'Y'
                                                        ? q7R
                                                        : []
                                                "
                                            >
                                                <v-radio
                                                    label="ไม่มี"
                                                    value="N"
                                                ></v-radio>
                                                <v-radio
                                                    label="มี"
                                                    value="Y"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>

                                    <!-- <v-row class="mt-5">
                                        <v-col cols="12">
                                            <span class="fh-2">
                                                8.
                                                เปิดลงทะเบียนจองวัคซีนทางเลือกยี่ห้อ
                                                Sinopharm ที่บริษัทจัดหาให้
                                                <br />
                                                <span
                                                    style="color:red !important;"
                                                    >หากพนักงานมาขอยกเลิกภายหลัง
                                                    จะมีการเรียกเก็บค่าใช้จ่ายจากพนักงานเต็มจำนวน</span
                                                >
                                            </span>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-20">
                                            <v-radio-group
                                                v-model="form_save.q8"
                                                :rules="q8R"
                                            >
                                                <v-radio
                                                    label="ขอจองรับวัคซีนทางเลือกที่ทางบริษัทฯ จะจัดหาให้  (เริ่มฉีดประมาณ ก.ค. 64)"
                                                    value="sinopharm"
                                                ></v-radio>
                                                <v-radio
                                                    label="ลงทะเบียนนัดฉีดวัคซีนไว้แล้ว "
                                                    value="registered"
                                                ></v-radio>
                                                <v-radio
                                                    label="ได้รับการฉีดวัคซีนเข็มแรกแล้ว หรือ ครบ 2 เข็มแล้ว"
                                                    value="vaccined"
                                                ></v-radio>
                                                <v-radio
                                                    label="ไม่สนใจฉีดวัคซีน"
                                                    value="no"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="8"
                                            md="10"
                                            class="mar-t-30"
                                            v-if="
                                                form_save.q8 == 'registered' ||
                                                    form_save.q8 == 'no'
                                            "
                                        >
                                            <v-text-field
                                                v-model="form_save.q8_remark"
                                                :rules="q8_remarkR"
                                                :label="
                                                    form_save.q8 == 'registered'
                                                        ? 'เข็มแรกวันที่... โปรดระบุ'
                                                        : 'เนื่องจาก...'
                                                "
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-30">
                                            <span style="color:red !important;"
                                                >เป้าหมายของบริษัทฯ
                                                พนักงานต้องได้รับการฉีดวัคซีนเข็มแรก
                                                Frontend 100% และ Backend 85%+
                                            </span>
                                        </v-col>
                                    </v-row> -->
                                </v-list-item-content>

                                <!-- <v-list-item-avatar tile size="80" color="grey">
                        </v-list-item-avatar> -->
                            </v-list-item>

                            <v-card-actions>
                                <!-- <v-spacer></v-spacer>
                                <v-btn
                                    rounded
                                    color="green"
                                    class="mb-3"
                                    :disabled="!valid"
                                    @click="save_form()"
                                >
                                    <span class="ml-3 mr-3 white--text"
                                        >บันทึกแบบสำรวจ</span
                                    >
                                </v-btn> -->
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-fade-transition>
        </v-form>
        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>

        <canvas
            style="display: none"
            id="photoTaken"
            ref="canvas"
            :width="450"
            :height="337.5"
        ></canvas>
    </div>
</template>
<script>
import { WebCam } from "vue-cam-vision"
import axios from "axios"
import { mapState, mapMutations } from "vuex"

export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
        checkpermission() {
            return true
        },
    },
    components: {
        WebCam,
    },
    beforeDestroy() {
        if (typeof window === "undefined") return

        window.removeEventListener("resize", this.onResize, { passive: true })
    },

    async beforeMount() {
        this.device =
            (await navigator.userAgent.indexOf("Windows")) != -1 ||
            (await navigator.userAgent.indexOf("Mac")) != -1
                ? "pc"
                : "mobile"
        await this.get_lan_lng()
        await this.createCameraElement()
    },
    mounted() {
        this.onResize()

        window.addEventListener("resize", this.onResize, { passive: true })
    },
    // mounted() {
    //     this.get_lan_lng()
    //     this.createCameraElement()
    // },
    // created() {
    //     setInterval(this.getNow, 1000)
    // },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        chk_active_camera() {
            let video = this.$refs.camerapc

            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices
                    .getUserMedia({ video: true })
                    .then(function(stream) {
                        video.srcObject = stream
                        video.play()
                    })
                    .catch((error) => {
                        this.$swal({
                            title: "Alert",
                            text:
                                "กรุณาตั้งค่าเปิดให้เข้าถึงกล้อง หรือ เปลี่ยนไปใช้เครื่องที่มีกล้อง และ Refresh ระบบใหม่อีกครั้ง",
                            icon: "warning",
                            button: false,
                            closeOnClickOutside: false,
                        })
                    })
            }
        },
        func_num(data) {
            // console.log(data)
            if (data == "Y") {
                this.num_1 = this.num_1 + 1
            } else {
                this.num_1 = this.num_1 - 1
            }
        },
        async get_lan_lng() {
            this.checkaddr()
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.gps.lat = position.coords.latitude
                    this.gps.lng = position.coords.longitude
                    this.chk_active_camera()
                },
                (error) => {
                    // console.log(error)
                    this.$swal({
                        title: "Alert",
                        text:
                            "กรุณาตั้งค่าเปิดให้เข้าถึง Location และ Refresh ระบบใหม่อีกครั้ง",
                        icon: "warning",
                        button: false,
                        closeOnClickOutside: false,
                    })
                }
            )

            const url = `${process.env.VUE_APP_ROOT_API}/api/getbranch`
            try {
                const { data } = await axios.get(`${url}`)
                this.branch_new = data
                // console.log("branch_new")
            } catch (error) {
                console.log(error)
            }
        },
        async checkstaff(params) {
            let chk = params[0] + params[1]

            let chk_p
            if (this.staff.emp_id == "qq") {
                chk_p = true
                this.staff.emp_id = "P19-063"
            }

            if (params.length == 3 && chk != "HM" && chk != "T0") {
                this.staff.emp_id = this.staff.emp_id + "-"
            }

            if (
                params.length == 7 ||
                (chk == "HM" && params.length == 5) ||
                (chk == "T0" && params.length == 4) ||
                chk_p == true
            ) {
                this.clear_state()
                await axios
                    .post(
                        `${process.env.VUE_APP_ROOT_API}/api/check-staff-covid`,
                        this.staff
                    )
                    .then((response) => {
                        // console.log(response, "-response")
                        if (response.data.status == "ok") {
                            this.data = response.data
                            this.form_save.q4_onsite = response.data.q4_onsite
                            if (this.data.detail != null) {
                                this.form_save = response.data.detail
                            }
                            // console.log(this.form_save)
                        } else if (response.data.status == "error") {
                            swal({
                                title: response.data.detail,
                                text: "Fail !",
                                icon: "error",
                                timer: 2000,
                                button: false,
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.data = []
            }
        },
        async checkaddr() {
            var gps = {
                lat: this.gps.lat.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0],
                lng: this.gps.lng.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0],
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/check-location`
            try {
                const { data } = await axios.post(`${url}`, gps)
                const ip = await axios.get(`https://api.ipify.org?format=json`)
                this.staff.ip = ip.data.ip
                this.branch = data
            } catch (error) {
                console.log(error)
            }
        },
        async onCapture() {
            await this.stamptime()
        },

        async stamptime() {
            const context = this.$refs.canvas.getContext("2d")
            if (this.device == "pc") {
                context.drawImage(this.$refs.camerapc, 0, 0, 450, 337.5)
            } else {
                context.drawImage(this.$refs.cameramoblie, 0, 0, 450, 337.5)
            }
            // console.log(context)
            this.staff.img = document
                .getElementById("photoTaken")
                .toDataURL("image/jpeg")

            this.staff.lat = this.gps.lat
            this.staff.lng = this.gps.lng
            this.staff.remark = this.data.remark
            this.staff.device = this.device
            this.staff.branch_id = this.distance_used.branch_id
            // this.staff.img = this.img;

            const url = `${process.env.VUE_APP_ROOT_API}/api/save-att`
            try {
                const { data, status } = await axios.post(`${url}`, this.staff)
                if (status == 200 && data.status != "error") {
                    var imgshow = `${process.env.VUE_APP_ROOT_API}/api/time-att/image/${data.img}`
                    this.$swal({
                        title: "ลงเวลาเรียบร้อย !",
                        text: data.time,
                        icon: imgshow,
                        timer: 2000,
                        buttons: false,
                    }).then(() => {
                        this.staff = {
                            emp_id: "",
                            remark: "",
                            img: "",
                            lat: "",
                            lng: "",
                            ip: "",
                            device: "",
                            branch_id: "",
                        }
                        this.data = []
                        // this.createCameraElement();
                    })
                }
            } catch (error) {
                console.log(error)
            }
        },

        createCameraElement() {
            const constraints = (window.constraints = {
                audio: false,
                video: true,
            })

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    // if (this.device == "pc") {
                    this.$refs.camerapc.srcObject = stream
                    // } else {
                    //     this.$refs.cameramoblie.srcObject = stream
                    // }
                })
                .catch((error) => {})
        },
        distance(lat1, lon1, lat2, lon2, unit) {
            if (lat1 == lat2 && lon1 == lon2) {
                return 0
            } else {
                var radlat1 = (Math.PI * lat1) / 180
                var radlat2 = (Math.PI * lat2) / 180
                var theta = lon1 - lon2
                var radtheta = (Math.PI * theta) / 180
                var dist =
                    Math.sin(radlat1) * Math.sin(radlat2) +
                    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
                if (dist > 1) {
                    dist = 1
                }
                dist = Math.acos(dist)
                dist = (dist * 180) / Math.PI
                dist = dist * 60 * 1.1515
                if (unit == "K") {
                    dist = dist * 1.609344
                }
                if (unit == "N") {
                    dist = dist * 0.8684
                }
                return dist
            }
        },
        caldistance() {
            this.branch_new.map((each) => {
                var radlat1 = (Math.PI * this.gps.lat) / 180
                var radlat2 = (Math.PI * each.branch_lat) / 180
                var theta = this.gps.lng - each.branch_lng
                var radtheta = (Math.PI * theta) / 180
                var dist =
                    Math.sin(radlat1) * Math.sin(radlat2) +
                    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
                if (dist > 1) {
                    dist = 1
                }
                dist = Math.acos(dist)
                dist = (dist * 180) / Math.PI
                dist = dist * 60 * 1.1515
                dist = dist * 1.609344
                this.distance_cal.push({
                    km: Number(
                        dist.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0]
                    ),
                    branch_name: each.branch_name,
                    branch_id: each.branch_id,
                })
            })
        },
        async checkaddr() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/check-location`
            try {
                const { data } = await axios.post(`${url}`, this.gps)
                const ip = await axios.get(`https://api.ipify.org?format=json`)
                // console.log(ip.data.ip)
                this.staff.ip = ip.data.ip
                this.branch = data
            } catch (error) {
                console.log(error)
            }
        },
        onResize() {
            this.isMobile = window.innerWidth < 600
        },
        save_form() {
            this.$swal({
                title: "กรุณายืนยัน ข้อมูลที่กรอกถูกต้องครบถ้วน ใช่ หรือ ไม่ ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    const context = this.$refs.canvas.getContext("2d")
                    if (this.device == "pc") {
                        context.drawImage(this.$refs.camerapc, 0, 0, 450, 337.5)
                    } else {
                        context.drawImage(
                            // this.$refs.camerapc,
                            this.$refs.camerapc,
                            0,
                            0,
                            450,
                            337.5
                        )
                    }
                    let devicex
                    this.isMobile == true
                        ? (devicex = "mobile")
                        : (devicex = "pc")

                    let send = {
                        data: this.form_save,
                        emp_id: this.staff.emp_id,
                        branch_id: this.staff.branch_id,
                        km: this.distance_used.km,
                        device: devicex,
                        ip: this.staff.ip,
                        lat: this.gps.lat,
                        lng: this.gps.lng,
                        img_path: document
                            .getElementById("photoTaken")
                            .toDataURL("image/jpeg"),
                    }

                    // console.log(send)

                    this.mutateIsLoading()
                    axios
                        .post(
                            `${process.env.VUE_APP_ROOT_API}/api/save-covid-survey`,
                            send
                        )
                        .then((response) => {
                            this.show = response.data
                            this.mutateIsLoading()
                            this.chk_save = true
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch(function(error) {
                            console.log(error, "-- error close case")
                        })
                }
            })
        },
        clear_state() {
            this.num_1 = 0
            this.form_save.q1_1 = ""
            this.form_save.q1_2 = ""
            this.form_save.q1_3 = ""
            this.form_save.q1_4 = ""
            this.form_save.q1_5 = ""
            this.form_save.q1_6 = ""
            this.form_save.q1_7 = ""
            this.form_save.q1_8 = ""
            this.form_save.q1_9 = ""
            this.form_save.q1_10 = ""
            this.form_save.q1_11 = ""
            this.form_save.q1_12 = ""
            this.form_save.q1_13 = ""
            this.form_save.q1_14 = ""
            this.form_save.q2 = ""
            this.form_save.q2_remark = ""
            this.form_save.q3 = ""
            this.form_save.q3_remark = ""
            this.form_save.q4 = ""
            this.form_save.q4_remark = ""
            this.form_save.q4_1 = ""
            this.form_save.q4_1_remark = ""
            this.form_save.q4_2_1 = ""
            this.form_save.q4_2_2 = ""
            this.form_save.q4_2_3 = ""
            this.form_save.q4_2_4 = ""
            this.form_save.q4_2_5 = ""
            this.form_save.q5 = ""
            this.form_save.q5_remark = ""
            this.form_save.q6 = ""
            this.form_save.q6_remark = ""
            this.form_save.q7 = ""
            this.form_save.q4_onsite = ""
            this.form_save.q7_validate = ""
            this.form_save.q8 = ""
            this.form_save.q8_remark = ""
            // this.form_save.q8_phone2 = ""
            // this.distance_used = {}
            // this.gps.lat = ""
            // this.gps.lng = ""
        },
    },
    watch: {
        branch_new: function(newQuestion, oldQuestion) {
            if (this.gps.lat != "") {
                this.caldistance()
            }
        },
        "gps.lat": function(newQuestion, oldQuestion) {
            if (this.branch_new.length != 0) {
                this.caldistance()
            }
        },
        distance_cal: function(newQuestion, oldQuestion) {
            this.distance_used = this.distance_cal.reduce(function(prev, curr) {
                return prev["km"] < curr["km"] ? prev : curr
            })
            // if (this.distance_used.km > 0.1) {
            //     this.distance_used = {
            //         km: "000",
            //         branch_id: "Unknown",
            //         branch_name: "Unknown",
            //     }
            // }
            this.staff.branch_id = this.distance_used.branch_id
            // console.log(this.distance_used, "- TEST LOG , Page Covid")
        },
    },
    data() {
        return {
            num_1: 0,
            device: "",
            staff: {
                emp_id: "",
                remark: "",
                img: "",
                lat: "",
                lng: "",
                ip: "",
                device: "",
                branch_id: "",
            },
            captures: [],
            member: {
                name: localStorage.fullname,
                team: localStorage.team_name,
                img: localStorage.emp_img,
            },
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/time-att/image/`,
            gps: {
                lat: "",
                lng: "",
            },
            branch: [],
            data: [],
            img: null,
            branch_new: [],
            distance_cal: [],
            distance_used: {},

            //new
            show: {
                emp_id: "",
                time: "",
                date_survey: "",
            },
            isMobile: false,
            form_save: {
                q1_1: "",
                q1_2: "",
                q1_3: "",
                q1_4: "",
                q1_5: "",
                q1_6: "",
                q1_7: "",
                q1_8: "",
                q1_9: "",
                q1_10: "",
                q1_11: "",
                q1_12: "",
                q1_13: "",
                q1_14: "",
                q2: "",
                q2_remark: "",
                q3: "",
                q3_remark: "",
                q4: "",
                q4_remark: "",
                q4_1: "",
                q4_1_remark: "",
                q4_2_1: "",
                q4_2_2: "",
                q4_2_3: "",
                q4_2_4: "",
                q4_2_5: "",
                q5: "",
                q5_remark: "",
                q6: "",
                q6_remark: "",
                q7: "",
                q4_onsite: "",
                q7_validate: "",
                q8: "",
                q8_remark: "",
                // q8_phone: "",
                // q8_phone2: "",
            },
            // empR: {
            //     required: (value) => !!value || "Required.",
            //     counter: (value) => value.length <= 7 || "Max 7 characters",
            // },
            empR: [(v) => v.length <= 7 || "Max 7 characters"],
            q2R: [
                (v) =>
                    !!v ||
                    "โปรดระบุใน 7วันที่ผ่านมา พนง. หรือคนในบ้านเดินทางไป ตจว หรือไม่",
            ],
            q2R_remark: [(v) => !!v || "โปรดระบุ...จังหวัด"],
            q3R: [
                (v) =>
                    !!v ||
                    "โปรดระบุคนในครอบครัวหรือชุมชนที่ท่านอาศัยอยู่ ได้มีการตรวจโควิดหรือไม่",
            ],
            q3R_remark: [(v) => !!v || "โปรดระบุ...ความใกล้ชิด"],
            q4R: [
                (v) =>
                    !!v ||
                    "โปรดระบุใน 24 ชม.ที่ผ่านมาท่านได้เดินทางไป ตจว / บ้านญาติ / บ้านเพื่อน / 7ELEVEN/ ตลาด - ตลาดนัด / ห้างสรรพสินค้า(ในจังหวัด) หรือ นัดพบเพื่อน หรือไม่",
            ],
            q4R_remark: [(v) => !!v || "โปรดระบุ...สถานที่"],
            q41R: [
                (v) =>
                    !!v ||
                    "โปรดระบุใน 24 ชม.ได้มีการนัดพบเพื่อน พนงบริษัทฯ นอกบริษัท หรือไม่",
            ],
            q41R_remark: [(v) => !!v || "โปรดระบุชื่อ..."],
            q421R: [(v) => !!v || "โปรดระบุุุ... Time line 19:01 น. - 7.00 น."],
            q422R: [(v) => !!v || "โปรดระบุ... Time line 07.01 น. – 10.00 น."],
            q423R: [(v) => !!v || "โปรดระบุ... Time line 10.00 น. – 13.00 น."],
            q424R: [(v) => !!v || "โปรดระบุ... Time line 13.01 น. – 16.00 น."],
            q425R: [(v) => !!v || "โปรดระบุ... Time line 16.01 น. – 19.00 น."],
            q5R: [
                (v) =>
                    !!v ||
                    "โปรดระบุหลังเลิกงานมี นัดเจอกินดื่ม มากกว่า2คนขึ้นไป",
            ],
            q5R_remark: [(v) => !!v || "โปรดระบุ...ความสัมพันธ์"],
            q6R: [
                (v) =>
                    !!v ||
                    "โปรดระบุวันนี้ท่านมีสนทนาโดยไม่ใส่หน้ากากกับบุคคลใดบ้าง",
            ],
            q6R_remark: [(v) => !!v || "โปรดระบุ...ความสัมพันธ์"],
            q7R: [
                (v) =>
                    !!v ||
                    "โปรดระบุใน24ชม. ที่ผ่านมาท่านล้างมือด้วยแอลกอฮอล์ขณะปฎิบัติหน้าที่หรือไม่(เฉพาะ SVC / Onsite)",
            ],
            q8R: [(v) => !!v || "โปรดระบุ..."],
            q8_remarkR: [(v) => !!v || "โปรดระบุเหตุผลข้อ 8 "],
            valid: false,
            chk_save: false,
        }
    },
}
</script>
<style scoped>
.swal-icon:first-child {
    width: 300px !important;
}
.v-input .v-label {
    font-size: 3em;
}
.fh-11 {
    color: rgb(26, 43, 90) !important;
    font-size: 22px;
    font-weight: bold;
}
.fh-1 {
    color: rgb(35, 42, 61) !important;
    font-size: 18px;
    font-weight: bold;
}
.fh-2 {
    color: rgb(34, 56, 117) !important;
    font-size: 18px;
    font-weight: bold;
}

.fh-3 {
    color: rgb(35, 42, 61) !important;
    font-size: 16px;
    font-weight: bold;
}

.fh-4 {
    color: rgb(38, 158, 48) !important;
    font-size: 22px;
    font-weight: bold;
}

.fh-44 {
    color: rgb(45, 158, 60) !important;
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px !important;
}

.fh-444 {
    color: rgb(233, 31, 31) !important;
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px !important;
}
</style>
